import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var selectSlot = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_ggursb0',variantClassNames:{side:{left:'fx_2d2fb1e5_ggursb1',right:'fx_2d2fb1e5_ggursb2'}},defaultVariants:{},compoundVariants:[]});

export { selectSlot };
//# sourceMappingURL=slot.vanilla.mjs.map
